import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef } from '@angular/material/dialog';

import { SnCallSign } from 'libs/api/entities/src/lib/team';
import { SnUser } from 'libs/api/entities/src/lib/user';

// TODO Migrate to form generator
@Component({
  selector: 'sn-direct-form',
  templateUrl: './direct-form.component.html',
  styleUrls: ['./direct-form.component.scss'],
})
export class SnDirectFormComponent implements OnInit {
  @Input()
  public isLoading = false;

  @Input()
  public exceptionList: string[];

  @Input()
  public submitButtonName = 'CREATE';

  @Input()
  public title: string;

  @Input()
  public isExternalAllowed: boolean;

  @Input()
  public formErrors;

  @Output()
  public readonly send = new EventEmitter<Object>();

  public form: UntypedFormGroup;

  public extInvite: boolean = false;
  public callsigns: SnCallSign[] = [];
  public callSignUsers: SnUser[] = [];
  public isLoadingCallSignUsers: boolean = false;

  constructor(
    private readonly _formBuilder: UntypedFormBuilder,
    private readonly _matDialogRef: MatDialogRef<SnDirectFormComponent>,
    private readonly _cd: ChangeDetectorRef,
  ) {}

  get usersControl(): AbstractControl {
    return this.form.get('users');
  }

  get emailControl(): AbstractControl {
    return this.form.get('email');
  }

  get dateControl(): AbstractControl {
    return this.form.get('date');
  }

  get HasUsersControlErrors(): boolean {
    return this.usersControl.touched && this.usersControl.hasError('required');
  }

  public ngOnInit(): void {
    this._initForm();
  }

  public onChange(event: MatCheckboxChange): void {
    this.extInvite = event.checked;
  }

  public cancel(): void {
    this._matDialogRef.close();
  }

  public sendFormData(): void {
    if (this.formErrors) {
      this.formErrors = null;
    }
    this.send.emit(this.form.value);
    this._cd.detectChanges();
  }

  private _initForm(): void {
    this.form = this._formBuilder.group({
      email: [[], Validators.email],
      date: null,
      toggle: false,
      users: [[]],
    });
  }
}
